import { bulk as updateCustomers } from '../../customers/actions/update-data';

export function request(id, query) {
    return {
        type: 'TRANSACTIONS_QUERY_REQUEST',
        query,
        id
    };
}

export function error(id, errors) {
    return {
        type: 'TRANSACTIONS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, transactions, customers) {
    return (dispatch) => {
        dispatch(updateCustomers(customers));

        for (let transaction of transactions) {
            if (transaction.details && transaction.details.assignee) {
                transaction.assignee = transaction.details.assignee;
                delete transaction.details.assignee;
            }
        }

        dispatch({
            type: 'TRANSACTIONS_QUERY_FINISH',
            transactions,
            id
        });
    };
}

export function clear(id) {
    return {
        type: 'TRANSACTIONS_QUERY_CLEAR',
        id
    };
}
